export default __webpack_public_path__ + "static/referralls-webflow-card-phone-mobile-7b3195f8315808c6e2e25d9cec1a6fca.png";